import {useRouter} from 'next/router';
import {Currency} from '@interface/index';
import {GameLogicInterface} from 'poker-interfaces';

// eslint-disable-next-line import/prefer-default-export
export const useCurrencyId = (): Currency => {
  const router = useRouter();

  const {currencyId} = router.query;
  const currencyIdQuery = currencyId as Currency;

  if (typeof currencyIdQuery === 'undefined' || currencyIdQuery === 'coin') {
    return 'coin';
  }
  if (currencyIdQuery === 'demo-coin') {
    return 'demo-coin';
  }
  return 'coin';
};

export const useGameMode = (): {gameType: GameLogicInterface.GameType; isAllIn: boolean} => {
  const router = useRouter();
  const {gameType, isAllIn: tempAllIn} = router.query;
  const gameModeQuery = gameType as GameLogicInterface.GameType;
  const isAllIn = tempAllIn === 'true';
  return {gameType: gameModeQuery, isAllIn};
};
